import { render, staticRenderFns } from "./ShareSlider.vue?vue&type=template&id=5585dd8d&scoped=true&"
import script from "./ShareSlider.vue?vue&type=script&lang=js&"
export * from "./ShareSlider.vue?vue&type=script&lang=js&"
import style0 from "./ShareSlider.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ShareSlider.vue?vue&type=style&index=1&id=5585dd8d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5585dd8d",
  null
  
)

export default component.exports